<template>
  <div class="default-events">
    <div class="default-container">
       
      <div class="row align-center search-row">
        <!-- Search -->
        <div class="columns small-12 medium-12 large-8 event-search">
          <div :class="''">
            <div class="input-group">
              <span class="input-group-label" @click="$refs.searchInput.focus()">
                <i class="fi-magnifying-glass"></i>
              </span>
              <input ref="searchInput"
                placeholder="Search..."
                v-on:input="search($event.target.value)" 
                class="input-group-field" 
                type="search" @focus="hideMenus"
                v-bind:value="$route.query.match">
              <span @click="removeSearchQuery" class="input-group-label hover clear-search">
                <i class="fi-x"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
        <!-- /Search -->
      <div class="row align-center event-buttons">
        <!-- Date Selector -->
        <div class="columns small-12 medium-6 large-4 event-date">
          <a class="button expanded" 
            @click="showDate = !showDate">Events by Date <span :class="[(showDate)? 'up triangle' : 'down triangle']"> </span></a>
          <div class="dropdown">
            <div :class="[(showDate)? 'dropdown-pane is-open' : 'dropdown-pane']">
              <div class="input-group">
                <span class="input-group-label" @click="openDate" data-toggle>
                  <i class="fi-calendar"></i>
                </span>
                <flat-pickr v-model="dateFilter" ref="datePickerWrap"
                  placeholder="Select Date Range"
                  :config="config" @on-change="dateChange"
                   @on-close="delayHideMenu"
                ></flat-pickr>
                <span @click="removeDateQuery" class="input-group-label hover clear-date">
                  <i class="fi-x"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- /Date Selector -->
        <!-- Type Selector --> 
        <div class="columns small-12 medium-6 large-4 event-type">
          <a class="button expanded type-button" 
            @click="showTypeMenu = !showTypeMenu">Events by Type <span :class="[(showTypeMenu)? 'up triangle' : 'down triangle']"> </span></a>  
          <div class="dropdown">
            <div :class="[(showTypeMenu)? 'dropdown-pane is-open' : 'dropdown-pane']">
              <div @click="typeMenuClick" class="dropdown-item"
                v-bind:data-value="false">Show All</div>
              <div @click="typeMenuClick" class="dropdown-item"
                v-for="t in types" 
                :key="t.type_id" 
                v-bind:data-value="t.type_id">{{ t.title }}</div>
            </div>
          </div>
        </div>
        <!-- /Type Selector --> 
       
      </div>
    </div>
    <!-- Date and Event Tags-->
     <div> 
       <span v-if="!!dateTagModel.displayText || eventTagModel.displayText" class="filter-text">Filter: </span>
        <span v-if="!!dateTagModel.displayText" :class="'label tagBtn'" >{{dateTagModel.displayText}} 
          <i class="fi-x xbtn"
            @click="removeValue" 
            :data-obj="JSON.stringify(dateTagModel)">
          </i>
        </span>
        <span v-if="!!eventTagModel.displayText" :class="'label tagBtn'" >{{eventTagModel.displayText}} 
            <i class="fi-x xbtn"
              @click="removeValue" 
              :data-obj="JSON.stringify(eventTagModel)" >
          </i>
        </span>
      </div>
    <!-- /Date and Event Tags-->
    <!-- Display Events -->
    <errors v-if="!events.records" />
    <list 
      v-if="!!events.records"
      :data="events.records" />
    <!-- /Display Events -->
    <!-- Pagination -->
    <div 
      v-if="limit < total" 
      class="row align-center event-pagination">
      <nav 
        aria-label="Pagination" 
        class="columns small-10 text-center">
        <ul class="pagination">
          <!-- Previous -->
          <li :class="[page === 1 ? 'pagination-previous disabled' : 'pagination-previous']" >
            <span v-if="page === 1">Previous</span>
            <a @click="prevClick"
              v-if="page > 1" 
              aria-label="Previous page" 
              >Previous <span class="show-for-sr">{{ page - 1 }}</span></a>
          </li>
          <!-- /Previous -->
          <!-- Page # -->
          <li 
            v-for="p in Math.ceil(total/limit)" 
            :key="p" 
            :class="getPaginationItemClasses(p)"
            >
            <span 
              v-if="p === page" 
              class="show-for-sr">You're on page</span>
            <a @click="pageClick(p)" >{{ p }}</a>
          </li>
          <!-- /Page # -->
          <!-- Next -->
          <li :class="[(page * limit) >= total ? 'pagination-next disabled' : 'pagination-next']">
            <span v-if="(page * limit) >= total">Next</span>
            <a  @click="nextClick"
              v-if="(page * limit) < total" 
              aria-label="Next page" 
              >Next <span class="show-for-sr">{{ page + 1 }}</span></a>
          </li>
          <!-- /Next -->
        </ul>
      </nav>
    </div>
    <!-- /Pagination -->
  </div>
</template>

<script>
import { getConfig, compareValues } from "../utils/index.js";
import List from "./views/list.vue";
import Errors from "./errors.vue";
import flatPickr from 'vue-flatpickr-component';
import { scrollIt } from '../utils/scroll.js';
import axios from 'axios'
let jsonpAdapter = require('axios-jsonp');
let sComponents = { List, flatPickr, Errors };

export default {
  name: "Events",
  components: sComponents,
  data: function() {
    return {
      events: {'records': []},
      types: [],
      searchFilter: "",
      typeFilter: "",
      dateFilter: [],
      showDate: false,
      showSearch: false,
      showTypeMenu: false,
      config: {
        mode:"range",
        minDate:"today",
        altFormat: "m-d-Y",
        altInput: true,
        dateFormat: "Y-m-d"
      },
      dateTagModel: {},
      eventTagModel: {},
    };
  },
  mounted: function(){
   
    this.getEvents(this.$route.query)
    this.getTypes()
    //expands events or dates selector based on ?expand='' query param
    if(this.$route.query.expand === 'event_date'){
        this.showDate = true;
      }
    if(this.$route.query.expand === 'event_type'){
        this.showTypeMenu = true;
      }
  },
  watch: {
    '$route' (to, from) {
      // react to route changes...
      this.getEvents(to.query)      
    }
  },
  computed: {
    limit() {
      return getConfig("limit");
    },
    page(){
      return this.calcPage(this.offset, this.limit)
    },
    total(){
      return this.events.total;
    },
    offset(){
      if(this.$route.query.offset){
        return this.$route.query.offset;
      }
      return 0
    }
  },
  methods: {
    getEvents: function(path){
      const vm = this
      const e = axios({
        url: getConfig("events"),
        adapter: jsonpAdapter,
        params: Object.assign({}, path, { limit: getConfig("limit") })
      }).then(({ data }) => {
        vm.events = Object.assign(data)
      }).catch(({}) => {})
    },
    getTypes: function(){
      const vm = this
      axios({
        url: getConfig("types"),
        adapter: jsonpAdapter
      }).then(({ data }) => {
        data.events.sort(compareValues('title'));
        vm.types = Object.assign(data.events)
      }).catch(({}) => {})
    },
    getPaginationItemClasses: function(p){
      // If current
      if(p === this.page){
        return 'current'
      }

      // Show only 5 page #'s
      // const showLimit = 5;
      // if(this.page <= showLimit/2){
        
      // }
      // if(p === (this.page + showLimit) || p === (this.page) ){
      //   return 'ellipsis'
      // }
      // if(p > (this.page + showLimit) || p < (this.page - showLimit)){
      //   return 'hide'
      // }
    },
    scrollToEl: function(el){
      const target = this.$el.getElementsByClassName(el);
      if(!!target[0]){
        scrollIt(
          target[0],
          500,
          'easeOutQuart'
        );
      }
    },
    prevClick: function(){
      this.scrollToEl('default-container')
      this.appendQuery({ offset: this.calcOffset(this.page-1) })
      // this.scrollToEl('event-list-container')
    },
    pageClick: function(p){
      if(this.page === p){
        return
      }
      this.scrollToEl('default-container')
      this.appendQuery({ offset: this.calcOffset(p) })
    },
    nextClick: function(){
      this.scrollToEl('default-container')
      this.appendQuery({ offset: this.calcOffset(this.page+1) })
      // this.scrollToEl('event-list-container')
    },
    calcOffset: function(page){
      return this.limit * (page -1)
    },
    calcPage: function(offset, limit){
      return (offset / limit) +1
    },
    openDate: function(){
      const calendar = this.$refs.datePickerWrap.fp;
      calendar.open()
    },
    dateChange: function(val, formatted){
      if(!!val){
        if(val.length === 2){
          let q = Object.assign({},this.$route.query)
          q = this.removeFromQuery('offset', q)
          let f = formatted.split(' to ')
          this.appendQuery({ "date[0]": f[0] })
          this.appendQuery({ "date[1]": f[1] })
          this.dateTagModel = ({
            "displayText": formatted,
            "value": {
              "date[0]": f[0], 
              "date[1]": f[1]
            }});
        }
      }
      
    },
    hideMenus: function(){
      this.showDate = false;
      this.showTypeMenu = false;
    },
    delayHideMenu: function(){
      const vm = this
      setTimeout(function(){
        vm.hideMenus()
      }, 500);
    },
    appendQuery: function(query){
      for(let i in query){
        if(!query[i]){
          delete query[i]
        }
      }
      let q = Object.assign({},this.$route.query)
      q = this.removeFromQuery('offset', q)
      this.$router.push({query: Object.assign({}, q, query)})
      
    },
    removeFromQuery: function(val, q){
      if(!!q[val]){
        delete q[val]
      }
      return q
    },
    removeSearchQuery: function(){
      // this.searchFilter = ''
      let q = Object.assign({},this.$route.query)
      q = this.removeFromQuery('match', q)
      this.$router.push({query: q})
    },
    removeDateQuery: function(){
      this.dateTagModel = {}
      this.dateFilter = []
      let q = Object.assign({},this.$route.query)
      q = this.removeFromQuery('date[0]', q)
      q = this.removeFromQuery('date[1]', q)
      this.$router.push({query: q})
    },
    removeValue: function(e){
      const obj = e.target.dataset.obj
      
      if (obj === JSON.stringify(this.eventTagModel) ){
        let q = Object.assign({},this.$route.query)
        let r = this.removeFromQuery('type_id', q);
        this.$router.push({query: r})
        this.eventTagModel = {};
      } else if(obj === JSON.stringify(this.dateTagModel)){
        this.dateTagModel = {};
        this.removeDateQuery();
      } 
    }, 
    search: function(val){
      if(val === ''){
        this.removeSearchQuery();
      }else {
      this.appendQuery({ match: val })
      }
    },
    typeMenuClick: function(e) {
      const value = e.target.dataset.value
      if (value) {
        this.appendQuery({ type_id: value });
        this.eventTagModel = {
          "displayText": e.target.textContent,
          "value": value
        }
      } else {
        this.eventTagModel = {};
        //if they click 'show all'
        let q = Object.assign({},this.$route.query)
        let r = this.removeFromQuery('type_id', q);
        this.$router.push({query: r})
      }

      // Close menus
      this.hideMenus()
    }
  }
};
</script>
<style lang="css" >
@import '../../node_modules/flatpickr/dist/flatpickr.min.css';
</style>
<style lang="scss">
.flatpickr-day.selected, .flatpickr-day.startRange, .flatpickr-day.endRange, .flatpickr-day.selected.inRange, .flatpickr-day.startRange.inRange, .flatpickr-day.endRange.inRange, .flatpickr-day.selected:focus, .flatpickr-day.startRange:focus, .flatpickr-day.endRange:focus, .flatpickr-day.selected:hover, .flatpickr-day.startRange:hover, .flatpickr-day.endRange:hover, .flatpickr-day.selected.prevMonthDay, .flatpickr-day.startRange.prevMonthDay, .flatpickr-day.endRange.prevMonthDay, .flatpickr-day.selected.nextMonthDay, .flatpickr-day.startRange.nextMonthDay, .flatpickr-day.endRange.nextMonthDay{
    background: #b77e46;
    border-color: #b77e46;
  }

.cove-events {
  .button{
    color: #fff;
    background-color: #63594e;
    padding: 1.1rem 1.1rem;
  }
  .columns{
    position: relative;
  }
  input[type=text]{
    margin: 0 !important;
  }
  input[readonly]{
    background-color: #F6F6F6;
  }
  input::placeholder{
    color: #afaaa5;
  }
  .input-group{
    padding-top: 1rem;
    .input-group-label{
      padding: 0;
      width: 40px;
      background-color: #e5e1dd;
      i {
        color: #63594e;
        padding: 0;
        font-size: 20px;
      }
    }
    .input-group-label:hover{
      cursor: pointer;
    }
    .input-group-label.hover{
      opacity: .2;
      position: absolute;
      background: none;
      border: none;
      right: 10px;
      top: 1.35rem;
    }
    .input-group-label.hover:hover{
      opacity: .6;
      transition: opacity 300ms;
      cursor: pointer;
    }
  }

  .dropdown{
    position: relative;
    width: 100%;
  }
  .dropdown-pane{
    width: 100%;
    margin-top: -1.00rem;
    border: 1px solid #dfdfdf;
    background-color: #fff;
    height: 0px;
    max-height: 0px;
    overflow: hidden;
    transition: max-height 300ms;
    background-color: #F2EEE9;
    padding: 0 1rem 1rem 1rem;
  }
  .is-open{
    max-height: inherit;
    height: inherit;
  }
  .tagBtn.label{
    align-items: center;
    background-color: #b77e46;
    border-radius: 4px;
    color: #b77e46;
    display: inline-flex;
    font-size: .75rem;
    height: 2em;
    justify-content: center;
    line-height: 1.5;
    padding-left: .75em;
    padding-right: .75em;
    white-space: nowrap;
    margin-top: 2rem;
    margin-right: 5px;
    }

    span .xbtn{
      margin-left: 5px;
    }
    .filter-text{
      color: #a89c8f;
      text-transform: uppercase;
      font-size: .85rem;
      font-weight: 700;

    }
  .search-row{
    
    padding-bottom: 0;
    border-bottom: none;
    .columns{
      padding-top: 0;
      padding-bottom: 0;
    }
  }
  .event-buttons{
    padding-top: 2rem!important;
    padding-bottom: 2rem!important;

    .columns{
      padding-top: 0!important;
      padding-bottom: 0!important;
    }
  }
  .event-date{
    z-index: 10;
  }
  .event-type{
    z-index: 9;
  }
  .dropdown-item{
    cursor: pointer;
    color: #63594e;
    padding-top: 1rem;
  }
  .dropdown-item:hover, .dropdown-item:focus{
    color: #b77e46;
  }
  .dropdown-item:active, .dropdown-item:visited{
    color: #63594e;
  }

  .triangle{
    width: 0;
    height: 8px;
    display: inline-block;
    margin-left: 4px;
  }
  .triangle.down{
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #fff;
  }
  .triangle.up{
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #fff;
    margin-bottom: 2px;
  }
  .event-pagination{
    border-bottom: 0;
  }
  .pagination{
    .ellipsis{
      cursor: default;
      padding-left: 0;
      padding-right: 0;
      // background-color: red;
      a{
        display: none;
      }
    }
    .ellipsis:hover{
      background: none;
    }
    li{
      
      margin-top: 1rem;
      a{
        padding: 1rem 1.5rem;
      }
      a:hover, a:focus{
        background-color: #f2f0ee;
      }
      a:active, a:visited{
        background: none;
      }
    }

    .current{
      background: none;
      a{
        color: #fff;
        background-color: #63594e;
      }
      a:hover, a:focus{
        color: #fff;
        background-color: #63594e;
      }
      a:active, a:visited{
        color: #fff;
        background-color: #63594e;
      }
    }
    
  }
}
</style>
